import {
  CreateAssetReviewDto,
  UpdateAssetReviewDto,
  UpdateAssetReviewCommentDto,
  SetAssetReviewCommentLikeDto,
  ReplyAssetReviewCommentDto,
  AssetReviewControllerDeleteAssetReviewParams,
  AssetReviewControllerGetAssetReviewParams,
  ShareAssetReviewLinkDTO,
  AssetReviewCommentsControllerListCommentPotentialMentionsParams,
  AssetReviewCommentsControllerGetAssetCommentsParams,
  AssetReviewCommentsControllerDeleteAssetCommentParams,
  MarkAssetReviewCommentsReadDto,
  CreateAssetReviewCommentDto,
  AddAssetReviewNotificationSubscriptionDto,
  AddAssetReviewVisitDto,
  AssetReviewControllerGetReviewContentParams,
  AssetReviewControllerListAssetReviewsParams,
  RequestParams,
  SetAssetReviewCommentResolveDto,
  AssetReviewControllerCountAssetReviewsParams
} from '@api/Api';
import { apiClient } from '@api/client';

export const createAssetReview = (data: CreateAssetReviewDto) =>
  apiClient.assetReview.assetReviewControllerCreateAssetReview(data);

export const getAssetReviewContent = (
  data: AssetReviewControllerGetReviewContentParams,
  params: RequestParams = {}
) => apiClient.assetReview.assetReviewControllerGetReviewContent(data, params);

export const getAssetReviewCount = (
  data: AssetReviewControllerCountAssetReviewsParams,
  params: RequestParams = {}
) => apiClient.assetReview.assetReviewControllerCountAssetReviews(data, params);

export const listAssetReviews = (
  data: AssetReviewControllerListAssetReviewsParams,
  params: RequestParams = {}
) => apiClient.assetReview.assetReviewControllerListAssetReviews(data, params);

export const updateAssetReview = (data: UpdateAssetReviewDto) =>
  apiClient.assetReview.assetReviewControllerUpdateAssetReview(data);

export const createCommentAssetReview = (data: CreateAssetReviewCommentDto) =>
  apiClient.assetReview.assetReviewCommentsControllerCreateAssetComment(data);

export const updateCommentAssetReview = (data: UpdateAssetReviewCommentDto) =>
  apiClient.assetReview.assetReviewCommentsControllerUpdateAssetComment(data);

export const deleteCommentAssetReview = (
  data: AssetReviewCommentsControllerDeleteAssetCommentParams
) =>
  apiClient.assetReview.assetReviewCommentsControllerDeleteAssetComment(data);

export const setCommentLikeAssetReview = (data: SetAssetReviewCommentLikeDto) =>
  apiClient.assetReview.assetReviewCommentsControllerSetAssetCommentLike(data);

export const setCommentResolveAssetReview = (
  data: SetAssetReviewCommentResolveDto
) =>
  apiClient.assetReview.assetReviewCommentsControllerSetAssetCommentResolve(
    data
  );

export const createReplyCommentAssetReview = (
  data: ReplyAssetReviewCommentDto
) => apiClient.assetReview.assetReviewCommentsControllerReplyAssetComment(data);

export const getCommentsAssetReview = (
  data: AssetReviewCommentsControllerGetAssetCommentsParams,
  params: RequestParams = {}
) =>
  apiClient.assetReview.assetReviewCommentsControllerGetAssetComments(
    data,
    params
  );

export const getPotentialMentionsAssetReview = (
  data: AssetReviewCommentsControllerListCommentPotentialMentionsParams
) =>
  apiClient.assetReview.assetReviewCommentsControllerListCommentPotentialMentions(
    data
  );

export const assetReviewDeleteAssetReview = (
  params: AssetReviewControllerDeleteAssetReviewParams
) => apiClient.assetReview.assetReviewControllerDeleteAssetReview(params);

export const assetReviewGetAssetReview = (
  data: AssetReviewControllerGetAssetReviewParams,
  params: RequestParams = {}
) => apiClient.assetReview.assetReviewControllerGetAssetReview(data, params);

export const shareAssetReviewLink = (params: ShareAssetReviewLinkDTO) =>
  apiClient.assetReview.assetReviewControllerShareAssetReviewLink(params);

export const addReviewVisit = (data: AddAssetReviewVisitDto) =>
  apiClient.assetReview.assetReviewControllerAddAssetReviewVisit(data);

export const addNotificationSubscription = (
  data: AddAssetReviewNotificationSubscriptionDto
) =>
  apiClient.assetReview.assetReviewControllerAddNotificationSubscription(data);

export const assetReviewCommentsMarkAssetCommentsRead = (
  data: MarkAssetReviewCommentsReadDto
) =>
  apiClient.assetReview.assetReviewCommentsControllerMarkAssetCommentsRead(
    data
  );
